<template>
  <modal title="Confirmation" size="xs" ref="modal">
    <h2 class="text-subtitle1">
      Are you sure you want to delete <strong>{{ name }}</strong>?
    </h2>
    <template v-slot:actions>
      <async-btn :task="task" label="Delete" color="negative" @click="deleteUser" />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { User, Modal as ModalElement } from '@/type';
import notify from '@/components/notify';
import Modal from '@/components/modal/Modal.vue';
import { deleteUser } from './user';

interface Data {
  task: Promise<void>|null
}

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    Modal,
    AsyncBtn,
  },
  props: {
    user: {
      type: Object as () => User,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  computed: {
    name(): string {
      return `${this.user.firstName} ${this.user.lastName}`;
    },
  },
  methods: {
    deleteUser() {
      this.task = deleteUser(this.user.id);
      this.task.then(() => {
        this.$emit('ok', this.user);
        notify(`${this.name} was deleted.`);
        (this.$refs.modal as ModalElement).hide();
      });
    },
  },
});
</script>
